import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Cash from '../icons/Cash';

export default function CashoutLink() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <Link to="/cash-out" className="diamonds-conversion-to-cash">
      <Cash />
      <span>{t('index_cash_out')}</span>
      <span className="diamonds-conversion-caret">
        <svg>
          <use
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xlinkHref="img/icons/economy.svg?1510677573844#ic_caret_right"
          />
        </svg>
      </span>
    </Link>
  );
}
